const UPSALE_POPUP_CALCULATION_METHODS = {
	SINGLE: 'single', // product metafield value
	MULTIPLE: 'multiple' // product metafield value
};

document.addEventListener('upsalePopup:open', (e) => {
	const upsaleScript = document.getElementById('upsale-popup-script');
	const upsaleQuantitiesToAdd = parseInt(upsaleScript.dataset.upsaleQuantitiesToAdd); // quantity to add per product
	if (!upsaleQuantitiesToAdd) {
		return;
	}

	const upsaleProducts = document.querySelectorAll('.upsale-product');
	if (!upsaleProducts.length) {
		return;
	}
	upsaleProducts.forEach((product) => {
		const quantityInput = product.querySelector('.upsale-quantity-input');
		const quantityCalculationMethod = quantityInput.dataset.quantityCalculationMethod;
		if (!quantityCalculationMethod || quantityCalculationMethod === UPSALE_POPUP_CALCULATION_METHODS.SINGLE) {
			return;
		}

		let upsaleQuantity = 1;
		if (quantityCalculationMethod === UPSALE_POPUP_CALCULATION_METHODS.MULTIPLE) {
			const productQuantity = e.detail.quantity;
			upsaleQuantity = Math.ceil(productQuantity / upsaleQuantitiesToAdd);
		}
		quantityInput.value = upsaleQuantity;

		const priceLabel = product.querySelector('.upsale-product-price');
		const newPrice = new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS' }).format((priceLabel.dataset.price * upsaleQuantity) / 100).replaceAll(/\s/g,''); // match price to quantity, format it to currency and trim spaces to match shopify money_with_currency display
		priceLabel.textContent = newPrice;
	});
});
